import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { HttpResponse } from "@angular/common/http";
import { ProviderService } from "../provider.service";
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from "sweetalert2";
import { OrganizationService } from '../../organization-management/organization.service';
// import Swal from "sweetalert2";
@Component({
  selector: 'app-add-biller',
  templateUrl: './add-biller.component.html',
  styleUrls: ['./add-biller.component.css']
})
export class AddBillerComponent implements OnInit {

  providerForm1: FormGroup;
  formSubmitted: boolean = false;
  showDesciptionError: boolean = true;
  featureList = [];
  finalFeatureList = [];
  temp: any;
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  organizationList = []

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private PlanService: ProviderService,
    private OrganizationService:OrganizationService
  ) { }

  ngOnInit() {
    this.initialiseForms();
  }

  getOrgs() {
    let query = ""
    this.OrganizationService.getOrganizationsApi(query).subscribe(res => {
      this.spinner.show();
      if ((res["status"] == "Success")) {
        this.organizationList = res.data.organizationList;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    }, err => {
      this.spinner.hide();
    });

  } 
  onlyNumberKey(event) {

    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }
  initialiseForms() {
    this.providerForm1 = this.fb.group({
      monthlyRedemptionCount: ["", [Validators.required]],
      description: ["", [Validators.required]],
      code: ["", [Validators.required]]

    });
    
  }


  Addplan() {
    this.formSubmitted = true;
    if (this.providerForm1.valid) {
      let request = this.providerForm1.value;
      this.PlanService.addCode(request).subscribe(data => {
        if ((data["status"] = "Success")) {
          Swal.fire("Success", "Billing Code Added successfully!", "success");
          this.router.navigate(["/main/provider/billercode"]);
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }




  }


  cancel() {
    this.router.navigate(["/main/provider/billercode"]);
  }
}



